/* AUTH */
export const LOGIN = "/portal/login";
export const GOOGLE_LOGIN = "/portal/google-login";
export const GET_ACCOUNT_DETAILS = "/portal/get-account-setting-data";
export const GET_PHONE_NUMBERS = "/portal/get-account-phones";
export const GET_EMAIL_IDS = "/portal/get-account-emails";
export const SEND_VERIFICATION = "/portal/send-verification-code";
export const CHANGE_CONTACT_OTP = "/portal/change-contact-otp";
export const UPDATE_PHONE = "/portal/update-phone";
export const UPDATE_EMAIL = "/portal/update-email";
export const UPDATE_ACCOUNT = "/portal/update-account";
export const VERIFY_OTP = "/portal/verify-otp";
export const SIGN_UP_GET_ACCOUNT = "/portal/get-accounts";
export const SIGN_UP = "/portal/signup";
export const SET_PASSWORD = "/portal/update-account-password";
export const FORGOT_PASSWORD = "/portal/forget-password";
export const RESET_PASSWORD = "/portal/reset-password";
export const REQUEST_ACCESS = "/portal/send-account-access-request";
export const GET_NOTIFICATION = "/portal/get-notifications";
export const GET_NOTIFICATION_COUNT = "/portal/get-unread-notifications-count";
export const NOTIFICATION_READ = "/portal/mark-read-activity-notification";
export const ACCOUNT_PERMISSION = "/portal/account-permissions";
export const GET_CUSTOMER_DETAILS = "/portal/get-customer-detail";
export const ADD_NOTIFICATION = "/portal/create-activity-details";
export const UPDATE_PROFILE_PICTURE = "/portal/update-profile-picture";
export const GET_PROFILE_PICTURE = "/portal/get-profile";
export const CHECKTOKEN = "/portal/check-token";
export const REFRESHTOKEN = "/portal/refresh-token";
export const GET_FINANCIAL_SETTINGS = "/portal/get-financial-settings";
export const GET_GENERAL_SETTINGS = "/payment/get-general-settings";
export const GET_ACCOUNT_ATTACH_MULTIPLE = "/portal/account-attach-multiple";
export const GET_PORTAL_SETTINGS = "/portal/get-portal-settings";
export const GET_MAINTENANCE_SETTINGS = "/portal/get-maintainence-settings";
export const GET_STATE_DISCLAIMER = "/portal/get-state-disclaimer";

/* PAYMENTS TAB AND SCHEDULE TAB */
export const GET_COUNT = "/portal/get-payment-history-status-count";
export const GET_PAYMENT_HISTORY = "/portal/get-payment-history";
export const GET_PAYMENT_RECEIPT = "/payment/portal-get-payment-recepit";
export const GET_TRANSACTION_DETAILS = "/payment/get-transaction-details";
export const VERIFY_REAUTH_PAYMENT = "/payment/verify-reauth-payment";
export const GET_ORDER_DETAILS = "/portal/get-order-details";
export const GET_LOGO = "/payment/get-company-logo";
export const GET_PREVIEW_DATA = "/payment/get-preview-data";
export const DOWNLOAD_PAYMENT = "/email/send-portal-process-payment-email";
export const GET_SCHEDULE_HISTORY = "/portal/get-schedules-payment-data";
export const DOWNLOAD_RECEIPT = "/portal/download";
export const DOWNLOAD_RECEIPT_PDF = "/portal/download-pdf";
export const DOWNLOAD_RECEIPT_AGREEMENT_PDF = "/portal/download-agreement-pdf";
export const GET_RECEIPT_ID = "/portal/get-receipt-id";

/* PAYMNET */
export const GET_PAYMENT_PERMISSION = "/portal/get-payment-permission";
export const WIRE_PAYMENT = "/payment/portal-wire-payment-process";
export const CREATE_CASHAPP_PAYMENT_PI = "/payment/create-payment-intents";
export const CREATE_PLAID_LINK_TOKEN = "/payment/get-plaid-link-token";
export const CREATE_PLAID_PAYMENT_TOKEN = "/payment/get-plaid-payment-token";
export const VERIFY_WALLET_PAYMENT = "/payment/verify-cashapp-payment";
export const PAYPAL_CREATE_PAY = "/payment/pay-pal-onetime-payment";
export const PAYPAL_ONETIME_COMPLETE = "/payment/success-onetime-payment";
export const PRODUCT_LINK_PAYMENT = "/payment/make-product-link-payment";
export const QUICK_CHECKOUT_PAYMENT = "/payment/make-quick-checkout-payment";
export const QUICK_CHECKOUT_CREATE_INTENT =
  "/payment/quick-checkout-create-intent";
export const GET_CON_FEE = "/payment/portal-get-con-fee";
export const MARK_INCOMPLETE_ORDER_FAILED = "/payment/mark-incomplete-failed";
export const SEND_PAYMENT_ASSISTANCE = "/email/send-payment-assistance-email";
export const VERIFY_STAX_PAYMENT = "/payment/verify-stax-payments";

/* DOCUMNET */
export const GET_ATTACHMENT_LIST = "/contact/get-user-attachment-details";
export const DOWNLOAD_ATTACHMENT = "/contact/download-attchement";
export const COUNTRY_STATE = "/contact/get-countries-with-states";

/* SUBSCRIPTION AND PLAN */
export const GET_SUBSCRIPTION_COUNT =
  "/portal/get-payment-plan-history-status-count";
export const GET_SUBSCRIPTION_HISTORY = "/portal/get-payment-plan-history";
export const CHECK_ACCOUNT_ACTIVE_SUBSCRIPTION =
  "/portal/check-account-active-subscription";
export const GET_DUE_AMOUNT = "/portal/get-due-amount";
export const UPDATE_SUBSCRIBE_PLAN = "/portal/update-plan";
export const CHARGE_CUSTOMER = "/payment/charge-customer";
export const CANCEL_SUBSCRIBE_PLAN = "/portal/cancel-plan";
export const DONT_CANCEL_SUBSCRIBE_PLAN = "/portal/dont-cancel-plan";
export const UPDATE_SUBSCRIBE_PAYMENT_METHOD =
  "/payment/update-subscription-payment-method";
export const GET_PENDING_SUBSCRIPTION_DETAILS =
  "/portal/get-plan-pending-schedule-details";
export const UPDATE_PLAN_PENDING_SCHEDULE =
  "/portal/update-plan-pending-schedule";

/* DASHBOARD */
export const GET_DASHBOARD_DATA = "/portal/get-dashboard-data";

/* PAYMENT METHOD */
export const GET_OLD_PAYMENT_METHODS = "/payment/get-old-cards";
export const DELETE_DEFAULT_CARD = "/portal/delete-payment-card";
export const CREATE_CARD = "/payment/portal-create-payment-card";
export const GET_COUNTRY_LIST = "/payment/get-country-list";
export const GET_PAYMENT_OFFER = "/payment/get-offers";
export const UPDATE_PAYMENT_PLAN = "/payment/portal-update-payment-plan";
export const SEND_SCHEDULE_UPDATED_EMAIL = "/email/send-schedule-updated-email";
export const PAYMENT_PLAN_PREVIEW = "/portal/get-schedule-plan-preview-data";
export const CANCEL_PAYMENT_PLAN = "/payment/cancel-payment-plan";
export const GET_SCHEDULE_DATA = "/portal/get-schedule-data";
export const GET_UPDATE_SUBSCRIPTION_DATA =
  "/portal/get-update-subscription-data";
export const GET_UPDATE_SCHEDULE_DATA = "/portal/get-update-schedule-data";
export const LEAD_DATA = "/contact/get-user-lead";
export const CREATE_WALLETS_PROFILE = "/payment/create-wallets-profile";
export const CREATE_STAX_PROFILE = "/payment/create-stax-profile";
export const GET_CARD_DETAILS = "/portal/get-card-details";

/* MAKE PAYMENT */
export const GET_SCHEDULE_PAYMENT = "/payment/get-payment-schedule";
export const GET_PLANS = "/payment/get-new-plan";
export const GET_CUSTOM_PLANS = "/payment/get-custom-plan";
export const MAKE_PAYMENT_GOOGLEPAY = "/payment/make-payment-google-pay";
export const GET_HOLIDAY_LIST = "/payment/get-holidays";
export const GET_SCHEDULE_INTERVAL = "/payment/get-schedule-date";
export const MAKE_ONETIME_PAYMENT = "/payment/make-onetime-payment";

/* ACTION CENTER */
export const GET_ACTION_COUNT = "/portal/get-payment-action-list-count";
export const GET_ACTION_LIST = "/portal/get-payment-action-list";
export const GET_PAYMENT_LINK = "/portal/get-payment-link-data";
export const SEND_EMAIL_RENEW_PAYMENT_LINK =
  "/portal/send-email-renew-paymet-link";
export const SEND_EMAIL_RENEW_AGREEMENT = "/portal/send-email-renew-agreement";
export const PROCESS_LINK = "/payment/process-customer-payment";
export const GET_PAYMENT_AGREEMENT = "/portal/get-agreement-data";
export const RESOLVE_LEGACY_AGREEMENT_SLUG =
  "/portal/resolve-legacy-agreement-slug";
export const RESOLVE_LEGACY_UPDATE_BILLING =
  "/portal/resolve-legacy-update-billing";
export const SIGN_AGREEMENT = "/payment/sign-agreement";
export const SUPPORT_PLANS = "/portal/support";
export const MAKE_PAYMENT = "/payment/make-payment";
export const DOWNLOAD_AGREEMENT_PDF = "/portal/get-agreement-pdf";
export const SEND_AGREEMENT_EMAIL = "/payment/send-signed-agreement-email";
export const GET_SCHEDULE_ID = "/payment/get-schedule-id";
export const GET_PAYMENT_DETAILS = "/portal/get-view-payment-data";
export const GET_MARKERS = "/payment/get-markers";
export const GET_PORTAL_MARKERS = "/payment/get-portal-company-markers";

/* STRIPE */
export const STRIPE_API = "https://api.stripe.com/v1/tokens";

/* SIGN UP FLOW */
export const CREATE_CUSTOMER = "/payment/create-stripe-customer";
export const DC_API = "https://api-qa.dcdial.com/api/";

/* PRODUCT LINK */
export const GET_PRODUCT_LINK_DETAILS = "/portal/get-product-link-data";
export const GET_QUICK_CHECKOUT_DETAILS = "/portal/get-quick-checkout-data";
export const GET_PRODUCTS = "/portal/get-products";

/* INVOICE */
export const GET_INVOICE_DETAILS = "/portal/get-invoice-details";
export const SEND_INVOICE = "/email/send-invoice-email";
export const INVOICE_UPDATE = "/portal/make-invoice-update";
export const INVOICE_PAYMENT = "/payment/make-invoice-payment";

/* QUOTES */
export const GET_QUOTE_DETAILS = "/portal/get-quotes-details";
export const ACCEPT_QUOTE = "/portal/accept-quote";
export const DECLINE_QUOTE = "/portal/decline-quote";
export const SEND_EMAIL_DECLINE_QUOTE = "/email/send-quote-declined-email";
export const SEND_EMAIL_ACCEPT_QUOTE = "/email/accept-quotes-invoice-email";

/* PAYPAL */
export const PAYPAL_TOKEN = "/payment/create-paypal-setup-token";
export const QUICK_CHECKOUT_PAYPAL_TOKEN =
  "/payment/quick-checkout-paypal-setup-token";
export const PAYPAL_PAYMENT_TOKEN = "/payment/create-paypal-payment-token";

/* DUPLICATE PAYMENT CHECK */
export const GET_DUPLICATE_PAYMENT = "/portal/get-duplicate-payment";

/* AI ASSISTANT
 * dcdial-nodejs-api-ai, mounted alongside the portal API on the same host.
 * AI_CHAT streams server-sent events, so it is called with fetch rather than
 * through apiInstance — see components/ai/aiApi.ts. */
export const AI_SESSION = "/ai/portal/session";
export const AI_SUGGESTIONS = "/ai/portal/suggestions";
export const AI_CHAT = "/ai/portal/chat";

/* ENVs */
const url = (process.env.REACT_APP_BASE_URL || "") as string;
export const REDIRECTION_URL = url?.endsWith("/") ? url : url + "/";
export const BASE_URL = process.env.REACT_APP_API_URL as string;
export const PROFILE_URL = process.env.REACT_APP_PROFILE_URL as string;
export const API_KEY = process.env.REACT_APP_API_KEY as string;
export const ENCDE_SECRET = process.env.REACT_APP_ENCDE_SECRET as string;
export const ENCDE_BASE = process.env.REACT_APP_ENCDE_BASE as string;
export const SIGNUP_PASS = process.env.REACT_APP_SIGNUP_PASS as string;
export const SIGNUP_USER = process.env.REACT_APP_SIGNUP_USER as string;
export const GOOGLE_MERCHANT_ID = process.env
  .REACT_APP_GOOGLE_MERCHANT_ID as string;
export const GOOGLE_MERCHANT_NAME = process.env
  .REACT_APP_GOOGLE_MERCHANT_NAME as string;
export const GOOGLE_CLIENT_ID = process.env
  .REACT_APP_GOOGLE_CLIENT_ID as string;

// export const BASE_URL = "http://localhost:3002";
